import HundredBricksAPIError from '../../HundredBricksAPIError';
class AmenitiesError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('AmenitiesError', ...args);
    }
}
export default AmenitiesError;
